import { useMemo } from "react";
import { useQuerySupportedAssets } from "./useQuerySupportedAssets";
import { getMetaCookie } from "@zapier/utils";
import { useCurrentAccountId } from "@zapier/identity";

export function useSupportedAssets() {
  const accountId = useCurrentAccountId();
  const { supportedAssets, isLoading, loadError } = useQuerySupportedAssets();

  // Zaps are supported by default, so any other assets will mean MPF is enabled
  // in some way
  const isMPFEnabled = useMemo(() => {
    // Use the cookie value while this is loading from Org service
    if ((supportedAssets.length === 0 || isLoading) && accountId) {
      const cachedMeta = getMetaCookie(accountId);
      return !!cachedMeta?.showAssetsSidebar;
    }
    return supportedAssets.length > 1;
  }, [supportedAssets, isLoading, accountId]);

  const assetChecks = useMemo(
    () => ({
      isZapsEnabled: supportedAssets.includes("zap"),
      isTablesEnabled: supportedAssets.includes("table"),
      isChatbotsEnabled: supportedAssets.includes("chatbot"),
      isInterfacesEnabled: supportedAssets.includes("interface"),
      isCanvasesEnabled: supportedAssets.includes("canvas"),
      isAgentsEnabled: supportedAssets.includes("agent"),
      isNextGenZapFoldersEnabled: supportedAssets.includes(
        "code_substrate_workflow",
      ),
    }),
    [supportedAssets],
  );

  return {
    loadError,
    _supportedAssets: supportedAssets,
    isMPFEnabled,
    isLoading,
    ...assetChecks,
  };
}
